import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'porcentagembrasil'
})
export class PorcentagemBrasilPipe implements PipeTransform {

  transform(numero: number): string {
    if (numero !== undefined && numero !== null) {
      return numero.toLocaleString('pt-BR') + '%';
    } else {
      return '';
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/_pipes/porcentagem-brasil.pipe.ts